import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0469baac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "boayClass"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "/xiaojing.png",
  style: {
    "width": "78.73px",
    "height": "83.25px"
  }
}), /*#__PURE__*/_createTextVNode("小鲸体育 ")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "username"
}, "账户:", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "username"
}, "密码:", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "username"
}, "验证码:", -1));
const _hoisted_7 = {
  class: "login-code"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn"
}, "登录", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "备案号：浙ICP备2024096554号-1")], -1));
import { showNotify } from '@nutui/nutui';
import { useStore } from 'vuex';
import request from '@/utils/request';
import service from '@/utils/request';
import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';
export default {
  __name: 'LoginView',
  setup(__props) {
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const store = useStore();
    const router = useRouter();
    const codeUrl = ref("");
    const captchaEnabled = ref(true);
    const loginForm = ref({
      username: localStorage.getItem("username") != undefined ? localStorage.getItem("username") : "",
      password: localStorage.getItem("password") != undefined ? localStorage.getItem("password") : "",
      code: "",
      uuid: ''
    });
    const getCode = () => {
      request.get('/captchaImage').then(res => {
        captchaEnabled.value = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (captchaEnabled.value) {
          codeUrl.value = 'data:image/gif;base64,' + res.img;
          loginForm.value.uuid = res.uuid;
        }
      });
    };
    const clickRegister = () => {
      router.push('/register');
    };
    const getInfo = () => {
      request.get('/getInfo').then(res => {
        if (res.code == 200) {
          // 登录成功，更新Vuex状态
          store.dispatch('login', res);
          localStorage.setItem('tabSwitch', 0);
          // 根据需要重定向到首页或其他页面
          router.push('/');
        }
      });
    };
    const handleSubmit = async () => {
      try {
        if (loginForm.value.username === "") {
          timeNotify("请输入您的账号");
        } else if (loginForm.value.password === "") {
          timeNotify("请输入您的密码");
        } else if (loginForm.value.code === "" && captchaEnabled.value) {
          timeNotify("请输入验证码");
        } else {
          // 发送登录请求
          const response = await service.post('/login', {
            username: loginForm.value.username,
            password: loginForm.value.password,
            code: loginForm.value.code,
            uuid: loginForm.value.uuid,
            loginType: 1
          });
          if (response.code == 200) {
            // 假设响应中包含一个token字段，我们将其保存到localStorage中
            const token = response.token;
            localStorage.setItem('token', token);
            localStorage.setItem('username', loginForm.value.username);
            localStorage.setItem('password', loginForm.value.password);
            getInfo();
          } else {
            timeNotify(response.msg);
            getCode();
            loginForm.value.code = '';
          }
        }
      } catch (error) {
        // 处理错误，比如显示错误信息
        console.error('Login failed:', error);
      }
    };
    onMounted(getCode);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("form", {
        onSubmit: _withModifiers(handleSubmit, ["prevent"])
      }, [_hoisted_4, _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "请输入账号",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loginForm.value.username = $event),
        required: ""
      }, null, 512), [[_vModelText, loginForm.value.username]]), _hoisted_5, _withDirectives(_createElementVNode("input", {
        type: "password",
        placeholder: "请输入密码",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => loginForm.value.password = $event),
        required: ""
      }, null, 512), [[_vModelText, loginForm.value.password]]), _hoisted_6, _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "验证码",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => loginForm.value.code = $event),
        maxlength: "4",
        style: {
          width: '100px'
        },
        required: ""
      }, null, 512), [[_vModelText, loginForm.value.code]]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        src: codeUrl.value,
        onClick: getCode,
        class: "login-code-img"
      }, null, 8, _hoisted_8)]), _hoisted_9], 32), _createElementVNode("span", null, [_createTextVNode("没有账号?"), _createElementVNode("text", {
        onClick: clickRegister
      }, "注册")])]), _hoisted_10]);
    };
  }
};